import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import ColorCreationSchema from "../../../../Schemas/ColorCreationSchema"

import {
  createColor,
  updateColor,
  getFirstAvailableColorCode,
} from "../../../../Services/ColorService";
import { useHistory } from "react-router-dom"; // useHistory for v5


function ColorCreationForm({
  data = {},
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      code: data.code|| "",
    },
    enableReinitialize: true,
    validationSchema: ColorCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5

  // Fetch first available code when not in edit mode
  useEffect(() => {
    const fetchFirstAvailableCode = async () => {
      if (!isEditMode) {
        try {
          const availableCode = await getFirstAvailableColorCode();
          if (availableCode) {
            formik.setFieldValue("code", availableCode);
          } else {
            // If no available code found (all 1-999 taken), use 001 as fallback
            formik.setFieldValue("code", "001");
          }
        } catch (error) {
          console.error("Error fetching first available color code:", error);
          // If error, start with 001
          formik.setFieldValue("code", "001");
        }
      }
    };

    fetchFirstAvailableCode();
  }, [isEditMode]);



  const handleSubmit = async () => {
    const values = formik.values;
    if (
      isEmpty(values.name) ||
      isEmpty(values.code)
    ) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createColor(values);
        message.success("Color created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the color list or wherever you want
      } else {
        const updatedColor = await updateColor(data._id, values);
        callReFetch();
        message.success(
          updatedColor?.data?.message || "Color updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };


  const { values } = formik;
  const titleText = isEditMode ? "Color Detail" : "Create Color";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & Code Tidak boleh duplicate
      </p>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Code hanya di antara 0 - 999
      </p>
      {!isEditMode && (
        <p style={{ display: "flex", justifyContent: "center", color: "#666", fontSize: "14px" }}>
          Code akan otomatis diisi dengan nomor yang tersedia pertama
        </p>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundColor: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter color name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Code" required>
            <Input
              name="code"
              placeholder="Enter color code"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // Allows only numbers (0-9)
                  let num = Number(value);
                  if (num >= 0 && num <= 999) {
                    let formattedValue = num.toString().padStart(3, "0"); // Ensures 3-digit format
                    formik.setFieldValue("code", formattedValue);
                  }
                }
              }}
              value={formik.values.code}
            />
          </Form.Item>{" "}
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

ColorCreationForm.propTypes = {

};

export default ColorCreationForm;
